"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.focusFirstInvalidInput = focusFirstInvalidInput;
_Object$defineProperty(exports, "getErrors", {
  enumerable: true,
  get: function () {
    return _getErrors.getErrors;
  }
});
_Object$defineProperty(exports, "getFirstKeyFromObject", {
  enumerable: true,
  get: function () {
    return _getFirstKeyFromObject.getFirstKeyFromObject;
  }
});
_Object$defineProperty(exports, "getFirstRegisteredInputByName", {
  enumerable: true,
  get: function () {
    return _getFirstRegisteredInputByName.getFirstRegisteredInputByName;
  }
});
var _getErrors = require("./get-errors");
var _getFirstKeyFromObject = require("./get-first-key-from-object");
var _getFirstRegisteredInputByName = require("./get-first-registered-input-by-name");
function focusFirstInvalidInput(inputsMap, shouldFocus) {
  if (shouldFocus) {
    const inputElement = (0, _getFirstRegisteredInputByName.getFirstRegisteredInputByName)(inputsMap, (0, _getFirstKeyFromObject.getFirstKeyFromObject)((0, _getErrors.getErrors)(inputsMap)));
    if (inputElement) {
      inputElement.focus();
    }
  }
}